import {makeEnumRuntimeType} from './apiTypes';

/*
 * Runtime Type.
 */

export enum CalendarWeekDaysEnum {
  SUNDAY = 'sunday',
  MONDAY = 'monday',
  TUESDAY = 'tuesday',
  WEDNESDAY = 'wednesday',
  THURSDAY = 'thursday',
  FRIDAY = 'friday',
  SATURDAY = 'saturday',
}

export enum CalendarWeekDaysShortEnum {
  SUNDAY = 'sun',
  MONDAY = 'mon',
  TUESDAY = 'tue',
  WEDNESDAY = 'wed',
  THURSDAY = 'thu',
  FRIDAY = 'fri',
  SATURDAY = 'sat',
}

export const RCalendarWeekDay = makeEnumRuntimeType(CalendarWeekDaysEnum);
